import React from 'react';
import PropTypes from 'prop-types';
import { FormFieldSpinnerUp, FormFieldSpinnerDown, } from '@wix/wix-ui-icons-common/system';
import { st, classes } from './WsrTicker.st.css';
import InputConsumer from '../InputConsumer';
import { dataHooks } from './constants';
const Ticker = ({ onUp, onDown, upDisabled, downDisabled, onMouseDown, dataHook, }) => (React.createElement(InputConsumer, { consumerCompName: Ticker.displayName }, ({ disabled, readOnly, size }) => {
    const isUpDisabled = upDisabled || disabled || readOnly;
    const isDownDisabled = downDisabled || disabled || readOnly;
    return (React.createElement("div", { className: st(classes.root, {
            size,
        }), onMouseDown: onMouseDown, "data-hook": dataHook },
        React.createElement("div", { "data-hook": dataHooks.tickerUp, "data-disabled": isUpDisabled, className: st(classes.up, { disabled: isUpDisabled }), onClick: isUpDisabled ? null : onUp },
            React.createElement(FormFieldSpinnerUp, null)),
        React.createElement("div", { "data-hook": dataHooks.tickerDown, "data-disabled": isDownDisabled, className: st(classes.down, { disabled: isDownDisabled }), onClick: isDownDisabled ? null : onDown },
            React.createElement(FormFieldSpinnerDown, null))));
}));
Ticker.displayName = 'Input.Ticker';
Ticker.propTypes = {
    onUp: PropTypes.func,
    onDown: PropTypes.func,
    upDisabled: PropTypes.bool,
    downDisabled: PropTypes.bool,
    onMouseDown: PropTypes.func,
    dataHook: PropTypes.string,
};
export default Ticker;
//# sourceMappingURL=Ticker.js.map